import React, { useState } from "react";
import { Image, Button, Icon, Confirm } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { image } from "../../../../assets";
import { User } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { BasicModal } from "../../../Shared";
import { UserForm } from "../UserForm";
import "./UserItem.scss";

const userController = new User();

export function UserItem(props) {
  const { user, onReload } = props;
  const { t } = useTranslation("users");

  const { accessToken } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [showconfirm, setShowconfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [isDelete, setIsDelete] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState); //esto es para abrir y cerrar el modal
  const onOpenCloseConfirm = () => setShowconfirm((prevState) => !prevState); //esto es para abrir y cerrar el modal

  const onOpenUpdateUser = () => {
    setTitleModal(t("item.updateTitle") + " " + user.email);
    onOpenCloseModal();
  };

  const onActivateDesactivete = async () => {
    try {
      await userController.updateUserActive(accessToken, user._id, {
        active: !user.active,
      });
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.log(error);
    }
  };

  const openDesactivateActivateconfirm = () => {
    setIsDelete(false);
    setConfirmMessage(
      user.active
        ? t("item.deactivateConfirm") + " " + user.email
        : t("item.activateConfirm") + " " + user.email,
    );
    onOpenCloseConfirm();
  };

  const openDeleteConfirm = () => {
    setIsDelete(true);
    setConfirmMessage(t("item.deleteConfirm") + " " + user.email);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await userController.deleteUser(accessToken, user._id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="user-item">
        <div className="user-item__info">
          <Image avatar src={user.avatar ? `${user.avatar}` : image.noAvatar} />
          <div>
            <p>
              {user.firstname} {user.lastname}
            </p>
            <p>{user.email}</p>
          </div>
        </div>
        <div>
          <Button icon primary onClick={onOpenUpdateUser}>
            <Icon name="pencil" />
          </Button>
          <Button
            icon
            color={user.active ? "orange" : "teal"}
            onClick={openDesactivateActivateconfirm}
          >
            <Icon name={user.active ? "ban" : "check"} />
          </Button>
          <Button icon color="red" onClick={openDeleteConfirm}>
            <Icon name="trash" />
          </Button>
        </div>
      </div>

      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal}>
        <UserForm close={onOpenCloseModal} onReload={onReload} user={user} />
      </BasicModal>
      <Confirm
        open={showconfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={isDelete ? onDelete : onActivateDesactivete}
        content={confirmMessage}
        size="mini"
      />
    </>
  );
}
